import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col items-start gap-3 p-6 pb-0 text-left" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  class: "h-6 w-6",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_4 = ["d"]
const _hoisted_5 = { class: "m-0 flex flex-wrap items-center gap-2.5 text-2xl font-bold text-textPrimary" }
const _hoisted_6 = {
  class: "h-6 w-6",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_7 = ["d"]
const _hoisted_8 = { class: "font-mono" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-wrap items-center gap-2"
}
const _hoisted_10 = {
  class: "flex flex-col gap-[18px] pb-6 pt-4 text-left",
  "data-testid": "affiliate-package-drawer"
}
const _hoisted_11 = {
  key: 0,
  class: "h-40 animate-pulse rounded-lg bg-lightGray30",
  "data-testid": "affiliate-drawer-loading"
}
const _hoisted_12 = {
  key: 1,
  class: "rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-[13px] text-red-700",
  "data-testid": "affiliate-drawer-error"
}
const _hoisted_13 = { class: "grid grid-cols-2 gap-x-4 gap-y-2.5" }
const _hoisted_14 = { class: "flex flex-col gap-0.5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-[11px] font-semibold uppercase tracking-wider text-neutral50" }, "Médico", -1)
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = { class: "flex flex-col gap-0.5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-[11px] font-semibold uppercase tracking-wider text-neutral50" }, "Unidade", -1)
const _hoisted_19 = { class: "font-semibold" }
const _hoisted_20 = { class: "flex flex-col gap-0.5" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-[11px] font-semibold uppercase tracking-wider text-neutral50" }, "Pedido em", -1)
const _hoisted_22 = { class: "font-semibold tabular-nums" }
const _hoisted_23 = { class: "flex flex-col gap-0.5" }
const _hoisted_24 = { class: "text-[11px] font-semibold uppercase tracking-wider text-neutral50" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-[11px] font-semibold uppercase tracking-wider text-neutral50" }, "Linha do tempo", -1)
const _hoisted_26 = { class: "m-0 mt-2.5 flex list-none flex-col p-0" }
const _hoisted_27 = ["data-testid"]
const _hoisted_28 = {
  key: 0,
  class: "absolute bottom-0 left-2.5 top-[22px] w-0.5 bg-lightGray30",
  "aria-hidden": "true"
}
const _hoisted_29 = {
  class: "h-3.5 w-3.5",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_30 = ["d"]
const _hoisted_31 = { class: "font-semibold" }
const _hoisted_32 = {
  key: 0,
  class: "text-xs text-neutral50"
}
const _hoisted_33 = {
  key: 1,
  class: "text-xs text-neutral50"
}
const _hoisted_34 = ["data-testid", "onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "text-[11px] font-semibold uppercase tracking-wider text-neutral50" }, "Plantões neste pacote", -1)
const _hoisted_36 = { class: "mt-2 flex flex-col rounded-lg border border-lightGray30" }
const _hoisted_37 = ["data-testid"]
const _hoisted_38 = { class: "tabular-nums" }
const _hoisted_39 = {
  key: 0,
  class: "ml-1 rounded border border-current px-1.5 text-[11px] font-bold text-neutral50"
}
const _hoisted_40 = { class: "text-xs text-neutral50" }
const _hoisted_41 = ["data-testid"]
const _hoisted_42 = { class: "tabular-nums" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 rounded border border-current px-1.5 text-[11px] font-bold text-orange-700" }, "Movido", -1)
const _hoisted_44 = { class: "text-xs text-neutral50" }
const _hoisted_45 = ["data-testid", "onClick"]
const _hoisted_46 = { class: "m-0 flex items-center gap-1.5 text-xs text-neutral50" }
const _hoisted_47 = {
  class: "h-4 w-4",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_48 = ["d"]

import { mdiArrowRight, mdiLockOutline, mdiPackageVariantClosed } from '@mdi/js'
import { computed, onMounted, onUnmounted } from 'vue'

import BaseSidebar from '@/components/designSystem/Sidebar/BaseSidebar.vue'
import { formatSlaDateTime } from '@/modules/company/Approvals/PriorityPayments/slaFormat'
import { useAntecipeAffiliateStore } from '@/pinia-store/useAntecipeAffiliateStore'

import { formatDayMonth, formatUnitNames, liveSlaState } from '../format'
import { buildTimeline } from '../timeline'
import type { TimelineTone } from '../timeline'
import { useNowTick } from '../useNowTick'
import AffiliatePackageClock from './AffiliatePackageClock.vue'
import AffiliateSlaBadge from './AffiliateSlaBadge.vue'
import AffiliateSplitTags from './AffiliateSplitTags.vue'
import AffiliateStageCell from './AffiliateStageCell.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliatePackageDrawer',
  setup(__props) {

const store = useAntecipeAffiliateStore()
const { nowMs } = useNowTick()

const detail = computed(() => store.drawer)
const pkg = computed(() => store.drawer?.package ?? null)
const timeline = computed(() => (store.drawer ? buildTimeline(store.drawer) : []))
const slaHours = computed(() => store.me?.slaHours ?? '')

const DOT_CLASS: Record<TimelineTone, string> = {
  done: 'bg-primary text-white',
  warn: 'bg-orange-100 text-orange-800',
  pending: 'bg-lightGray30 text-neutral50'
}

// Ruling F4: link sem pacote relacionado (null) não faz nada.
function openLinkedPackage(id: number | null): void {
  if (id !== null) void store.openPackage(id)
}

function onToggle(open: boolean): void {
  if (!open) store.closePackage()
}

function onKeydown(event: KeyboardEvent): void {
  if (event.key === 'Escape' && store.drawerPackageId !== null) store.closePackage()
}

onMounted(() => window.addEventListener('keydown', onKeydown))
onUnmounted(() => window.removeEventListener('keydown', onKeydown))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseSidebar, {
    "model-value": _unref(store).drawerPackageId !== null,
    width: "560px",
    "background-color": "#FFFFFF",
    "onUpdate:modelValue": onToggle
  }, {
    header: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "text-textPrimary",
          "aria-label": "Fechar",
          "data-testid": "affiliate-drawer-close",
          onClick: close
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_3, [
            _createElementVNode("path", { d: _unref(mdiArrowRight) }, null, 8, _hoisted_4)
          ]))
        ], 8, _hoisted_2),
        _createElementVNode("h2", _hoisted_5, [
          (_openBlock(), _createElementBlock("svg", _hoisted_6, [
            _createElementVNode("path", { d: _unref(mdiPackageVariantClosed) }, null, 8, _hoisted_7)
          ])),
          _createTextVNode(" Pacote "),
          _createElementVNode("span", _hoisted_8, "#" + _toDisplayString(_unref(store).drawerPackageId), 1),
          (pkg.value)
            ? (_openBlock(), _createBlock(AffiliateSplitTags, {
                key: 0,
                "origin-package-id": pkg.value.originPackageId,
                "split-to-package-ids": pkg.value.splitToPackageIds
              }, null, 8, ["origin-package-id", "split-to-package-ids"]))
            : _createCommentVNode("", true)
        ]),
        (pkg.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(AffiliateSlaBadge, {
                state: _unref(liveSlaState)(pkg.value, _unref(nowMs))
              }, null, 8, ["state"]),
              _createVNode(AffiliateStageCell, {
                stage: pkg.value.stage,
                "show-steps": false
              }, null, 8, ["stage"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        (_unref(store).isLoadingDrawer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11))
          : (_unref(store).drawerError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(store).drawerError), 1))
            : (detail.value && pkg.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("span", _hoisted_16, _toDisplayString(pkg.value.doctorName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(formatUnitNames)(pkg.value.units)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(formatSlaDateTime)(pkg.value.requestedAt)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(pkg.value.paidAt ? 'Tempo até pagar' : `Prazo (${slaHours.value} h)`), 1),
                      _createVNode(AffiliatePackageClock, {
                        row: pkg.value,
                        "now-ms": _unref(nowMs),
                        "test-id": "affiliate-drawer-clock"
                      }, null, 8, ["row", "now-ms"])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_25,
                    _createElementVNode("ol", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeline.value, (entry, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: entry.key,
                          class: "relative grid grid-cols-[22px_1fr] gap-2.5 pb-3.5",
                          "data-testid": `affiliate-timeline-${entry.key}`
                        }, [
                          (index < timeline.value.length - 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", {
                            class: _normalizeClass(["grid h-[22px] w-[22px] place-items-center rounded-full", DOT_CLASS[entry.tone]])
                          }, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_29, [
                              _createElementVNode("path", {
                                d: entry.icon
                              }, null, 8, _hoisted_30)
                            ]))
                          ], 2),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_31, _toDisplayString(entry.title), 1),
                            (entry.when)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(entry.when), 1))
                              : _createCommentVNode("", true),
                            (entry.description || entry.linkPackageId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _createTextVNode(_toDisplayString(entry.description) + " ", 1),
                                  (entry.linkPackageId)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "font-semibold text-primary underline underline-offset-2",
                                        "data-testid": `affiliate-timeline-link-${entry.linkPackageId}`,
                                        onClick: ($event: any) => (openLinkedPackage(entry.linkPackageId))
                                      }, " Abrir #" + _toDisplayString(entry.linkPackageId), 9, _hoisted_34))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_27))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.shifts, (shift) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: shift.doctorStationId,
                          class: "flex flex-wrap justify-between gap-2.5 border-b border-lightGray30 px-3 py-2.5 last:border-b-0",
                          "data-testid": `affiliate-drawer-shift-${shift.doctorStationId}`
                        }, [
                          _createElementVNode("span", null, [
                            _createElementVNode("b", _hoisted_38, _toDisplayString(_unref(formatDayMonth)(shift.date)), 1),
                            _createTextVNode(" · " + _toDisplayString(shift.startHour) + "–" + _toDisplayString(shift.endHour) + " ", 1),
                            (!shift.pertinent)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_39, " Fora das suas unidades "))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_40, _toDisplayString(shift.scheduleName) + " · " + _toDisplayString(shift.unitName), 1)
                        ], 8, _hoisted_37))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.movedShifts, (moved) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `moved-${moved.doctorStationId}`,
                          class: "flex flex-wrap justify-between gap-2.5 border-b border-lightGray30 bg-orange-50 px-3 py-2.5 last:border-b-0",
                          "data-testid": `affiliate-drawer-moved-${moved.doctorStationId}`
                        }, [
                          _createElementVNode("span", null, [
                            _createElementVNode("b", _hoisted_42, _toDisplayString(_unref(formatDayMonth)(moved.date)), 1),
                            _createTextVNode(" · " + _toDisplayString(moved.startHour) + "–" + _toDisplayString(moved.endHour) + " ", 1),
                            _hoisted_43
                          ]),
                          _createElementVNode("span", _hoisted_44, [
                            _createTextVNode(" Recusado na conferência · agora no "),
                            _createElementVNode("button", {
                              type: "button",
                              class: "font-semibold text-primary underline underline-offset-2",
                              "data-testid": `affiliate-moved-link-${moved.toPackageId}`,
                              onClick: ($event: any) => (openLinkedPackage(moved.toPackageId))
                            }, " #" + _toDisplayString(moved.toPackageId), 9, _hoisted_45)
                          ])
                        ], 8, _hoisted_41))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_46, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_47, [
                      _createElementVNode("path", { d: _unref(mdiLockOutline) }, null, 8, _hoisted_48)
                    ])),
                    _createTextVNode(" Valores, taxas e percentuais deste pacote não são exibidos no portal. ")
                  ])
                ], 64))
              : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})